module.exports = __webpack_public_path__ + "img/jingzhuang6.1a5a7f2a.jpg";